import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { DataService } from 'src/app/services/data.service';
import { ToastService } from 'src/app/services/toast.service';
import { Subscription } from 'rxjs';
import { InvitationAcceptRejectModalComponent } from './invitation-detailpage/invitation-model/invitation-model.component';
import { AccountAuthService } from '../auth/account-auth.service';
import { SubscriptionStatus } from '../subscription/models/subscription-usage.model';
import { InviteConfirmationModalComponent } from './invitation-detailpage/confirmation-modal/invite-confirmation-modal.component';
import { MapService } from 'src/app/services/map.service';
import { ip } from 'src/app/constant/constant';

@Component({
  selector: 'app-invitationpage',
  templateUrl: './invitationpage.component.html',
  styleUrls: ['./invitationpage.component.scss'],
  standalone: false,
})
export class InvitationpageComponent implements OnInit, OnDestroy {
  imageurl = ip;
  userid: any;
  previousinvitationlist: any[] = [];
  pendinginvitationlist: any[] = [];
  pendingMapInvitation: any[] = [];
  planUsage: SubscriptionStatus | null = null;
  count: number = 0;
  map_id: any;
  acceptingId: string | number | null = null;
  selectedTab: 'inbox' | 'history' = 'inbox';
  autoInviteId: string = '';
  activeParamsSubscription: Subscription;
  pre_accepted_character_id: string | number = '';

  constructor(
    private dataserv: DataService,
    private currentUserService: CurrentUserService,
    private router: Router,
    private accountAuth: AccountAuthService,
    private toastService: ToastService,
    private mapService: MapService,
    private cookieService: CookieService,
    private modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
  ) {}

  get pendingGames(): any[] {
    return this.pendinginvitationlist || [];
  }

  get pendingMaps(): any[] {
    return this.pendingMapInvitation || [];
  }

  get previousGames(): any[] {
    return this.previousinvitationlist || [];
  }

  get inboxCount(): number {
    return this.pendingGames.length + this.pendingMaps.length;
  }

  get historyCount(): number {
    return this.previousGames.length;
  }

  gameImg(item: any): string {
    return item?.gameimage ? this.imageurl + item.gameimage : 'assets/images/no_images.png';
  }

  mapImg(item: any): string {
    return item?.map_image ? this.imageurl + item.map_image : 'assets/images/no_images.png';
  }

  isAccepting(id: string | number): boolean {
    return this.acceptingId != null && String(this.acceptingId) === String(id);
  }

  statusKey(status: string): string {
    const s = (status || '').toLowerCase();
    if (s === 'accepted') return 'accepted';
    if (s === 'rejected' || s === 'declined') return 'declined';
    return 'closed';
  }

  statusLabel(status: string): string {
    const key = this.statusKey(status);
    if (key === 'accepted') return 'Accepted';
    if (key === 'declined') return 'Declined';
    return status || 'Closed';
  }

  ngOnDestroy(): void {
    this.activeParamsSubscription?.unsubscribe();
  }

  ngOnInit(): void {
    this.currentUserService.currentUser.subscribe((data) => {
      if (data) {
        this.userid = data.id;
        const params = this.activatedRoute.snapshot.params;

        if (!this.userid) {
          this.toastService.showNote('Please sign in first.', 'warning');
          this.accountAuth.signOut('/login', { returnTo: this.router.url });
          return;
        }
        if (params['userId']) {
          const invitationUserId = params['userId'];
          if (this.userid != invitationUserId) {
            this.toastService.showNote('This invitation is for a different account. Please sign in with that one.', 'danger');
            // Back here after signing in with the invited account.
            this.accountAuth.signOut('/login', { returnTo: this.router.url });
            return;
          }
        }
        this.getpreviousinvitation();
        this.getinvitation();
        this.getMapInvitationList();
        this.cdr.detectChanges();
      }
    });
    this.currentUserService.planUsageData.subscribe((data: SubscriptionStatus) => {
      if (data) {
        this.planUsage = data;
        this.cdr.detectChanges();
      }
    });
  }

  getpreviousinvitation() {
    this.dataserv
      .get_previous_invitationlist(this.userid)
      .subscribe((data: any) => {
        this.previousinvitationlist = data.Invitation_list || [];
        this.cdr.detectChanges();
      });
  }

  getinvitation() {
    this.dataserv
      .get_pending_invitationlist(this.userid)
      .subscribe((data: any) => {
        this.pendinginvitationlist = data.Invitation_list || [];
        this.activeParamsSubscription = this.activatedRoute.queryParams.subscribe(
          (params) => {
            if (params['autoInviteId'] && params['character_id']) {
              this.autoInviteId = params['autoInviteId'];
              this.pre_accepted_character_id = params['character_id'];

              if (this.isInInvitationList())
                this.navigateToInvitationDetail(this.autoInviteId);
            }
            this.cdr.detectChanges();
          },
        );
        this.cdr.detectChanges();
      });
  }

  isInInvitationList(): boolean {
    return this.pendinginvitationlist.some(
      (invitation) => invitation.id == this.autoInviteId,
    );
  }

  getMapInvitationList() {
    this.dataserv.getMapInvitationByUserId(this.userid).subscribe({
      next: (data: any) => {
        this.pendingMapInvitation = data?.invitations?.length ? data.invitations : [];
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.toastService.showSuccess(
          error.error?.message || error.message || 'Something went wrong. Please try again.',
          'danger',
        );
        this.cdr.detectChanges();
      },
    });
  }

  navigateToInvitationDetail(invitationId: string) {
    this.acceptingId = invitationId;
    const userId = String(this.userid);
    this.navigateInvitationDetai(userId, invitationId);
  }

  navigateInvitationDetai(userId, invitationId) {
    this.dataserv.get_invitationdetail(userId, invitationId).subscribe({
      next: (data: any) => {
        if (data && data.invitations?.length > 0) {
          const invitation = data.invitations[0];
          const map_id = data.invitations[0]?.map_id;
          this.map_id = map_id;
          this.getCharDetails(userId, this.map_id, invitation);
        }
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.acceptingId = null;
        this.toastService.showSuccess(
          err.error?.message || err?.message || 'This game was deleted',
          'danger',
        );
        this.cdr.detectChanges();
      },
    });
  }

  getCharDetails(userId, map_id, invitation) {
    this.dataserv.Getcharacterdetail(userId, map_id).subscribe({
      next: (data: any) => {
        const ishaveCharQuota = this.isHaveCharQuota();
        if (
          data &&
          data.character_details &&
          data.character_details?.length > 0
        ) {
          this.openModalAfterChecks(
            userId,
            invitation.id,
            this.pre_accepted_character_id,
            invitation.level,
            invitation.GameSystem,
          );
        } else {
          this.openConfirmationModal(ishaveCharQuota, invitation);
        }
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.acceptingId = null;
        this.toastService.showSuccess(
          err.error?.message || err?.message || 'This game was deleted',
          'danger',
        );
        this.cdr.detectChanges();
      },
    });
  }

  isHaveCharQuota(): boolean {
    if (!this.planUsage) return false;
    if (this.planUsage.subscription_features.max_active_characters === -1)
      return true;
    return (
      this.planUsage.subscription_features.max_active_characters >
      this.planUsage.usage.characters_created
    );
  }

  openConfirmationModal(ishaveCharQuota: boolean, invitation) {
    this.acceptingId = null;
    const modalRef = this.modalService.open(InviteConfirmationModalComponent, {
      size: 'sm',
      backdrop: 'static',
      centered: true,
    });

    modalRef.componentInstance.ishaveCharQuota = ishaveCharQuota;
    modalRef.componentInstance.invitattionDetailInstance = invitation;
    modalRef.componentInstance.map_id = this.map_id;
  }

  openModalAfterChecks(
    userId: any,
    invitationId: any,
    pre_accepted_character_id: any,
    playerLevel: any,
    GameSystem: any,
  ) {
    const addmodalRef = this.modalService.open(
      InvitationAcceptRejectModalComponent,
      {
        size: 'md',
        backdrop: 'static',
        centered: true,
      },
    );
    addmodalRef.componentInstance.userId = userId;
    addmodalRef.componentInstance.invitationId = invitationId;
    addmodalRef.componentInstance.playerLevel = playerLevel;
    addmodalRef.componentInstance.game_system = GameSystem;
    addmodalRef.componentInstance.pre_accepted_character_id =
      pre_accepted_character_id;

    addmodalRef.componentInstance.isUserCanCreateChar =
      !this.planUsage ||
      this.planUsage.subscription_features.max_active_characters >
        this.planUsage.usage.characters_created ||
      this.planUsage.subscription_features.max_active_characters === -1 ||
      false;
    this.acceptingId = null;
    addmodalRef.componentInstance.statusUpdated.subscribe(() => {
      this.getinvitation();
      this.getpreviousinvitation();
      this.getMapInvitationList();
      this.cdr.detectChanges();
    });

    addmodalRef.result.catch((reason) => {
    });
  }

  declineInvitation(invitationdata: any) {
    const data = {
      id: invitationdata.id,
      game_id: invitationdata.game_id,
      status: 'REJECTED',
      character_id: null,
      geography: null,
      culture: '',
    };
    this.dataserv.invitationdetailstatusupdate(data).subscribe({
      next: () => {
        this.toastService.showSuccess(
          'Invitation declined.',
          'success',
        );
        this.getinvitation();
        this.getpreviousinvitation();
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.toastService.showSuccess(
          err.error?.message || err?.message || 'This game was deleted',
          'danger',
        );
        this.cdr.detectChanges();
      },
    });
  }

  invitationAcceptRejectForMap(invitationId: string, action: string) {
    const payload = {
      invitation_id: invitationId,
      response: action,
    };
    this.dataserv.accept_reject_invitation_for_map(payload).subscribe({
      next: (data: any) => {
        if (data) {
          if (action === 'ACCEPTED') {
            this.toastService.showSuccess(
              'Invitation accepted successfully',
              'success',
            );
            this.mapService.getMapList(this.userid, true);
          } else {
            this.toastService.showSuccess(
              'Invitation rejected successfully',
              'success',
            );
          }
          this.getpreviousinvitation();
          this.getMapInvitationList();
          this.cdr.detectChanges();
        }
      },
      error: (error) => {
        this.toastService.showSuccess(
          error.error?.message || error.message || 'Something went wrong. Please try again.',
          'danger',
        );
        this.cdr.detectChanges();
      },
    });
  }
}
